import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useState} from "react";

export default function MarkerInfoForm(props) {
    const [name, setName] = useState('')
    const [desc, setDesc] = useState('')
    const [img, setImg] = useState('')



    const handleClose = () => {
        props.close(false);
    };
    const handleSave = () => {
        //save
        props.saveMarker(name,desc,img)
        props.close(false)
    }
    return (
        <div>
            <Dialog open={props.open} onClose={handleClose}>
                <DialogTitle>Marker Info</DialogTitle>
                <DialogContent >
                    <DialogContentText sx={{color:'white'}}>
                        아래 정보를 입력후 저장 하세요.
                    </DialogContentText>
                    <TextField  margin="dense" id="name" onChange={(e)=>setName(e.target.value)}
                         placeholder="회사 이름" fullWidth variant="standard"
                    />
                    <TextField  margin="dense" id="desc" onChange={(e)=>setDesc(e.target.value)}
                               placeholder="주소 또는 기타 설명"  fullWidth variant="standard"
                    />
                    <TextField  margin="dense" id="image" onChange={(e)=>setImg(e.target.value)}
                               placeholder="이미지파일 경로"  fullWidth variant="standard"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleSave}>save</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}